export default "__VITE_ASSET__C2$YZ$Nw__"